function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 2c-4.962 0-9 4.038-9 9 0 4.611 3.488 8.42 7.963 8.936.058-.151.104-.306.187-.448l.301-.515 4.957-8.5c.486-.833 1.355-1.357 2.305-1.452.097-.01.19-.037.289-.037a3.094 3.094 0 0 1 1.89.703C18.256 5.348 14.517 2 10 2zm0 4a1 1 0 0 1 1 1v4a1 1 0 0 1-.293.707L8.414 14A1 1 0 0 1 7 12.586l2-2V7a1 1 0 0 1 1-1zm7 4.984a.99.99 0 0 0-.863.496l-5.26 9.016A1 1 0 0 0 11.74 22h10.52a1 1 0 0 0 .863-1.504l-5.26-9.016a.99.99 0 0 0-.863-.496zM17 14a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
});

var SvgIcIdentityExpiredRound = function SvgIcIdentityExpiredRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcIdentityExpiredRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_identity_expired_round.14fbb5cc.svg";
export { ForwardRef as ReactComponent };